module.exports = __webpack_public_path__ + "img/charging-station.84ba06c6.svg";